/* global angular */

angular.module('gc.ui.textareaFocus', [])

/**
 * TODO change the name of the directive to "editable focus" or something like this
 * Focus the content editable child when click on the element target by the directive.
 */
.directive('textareaFocus', [
  '$parse',
  'LocalStorageService',
  'CommentService',
  'Utils',
function ($parse, LocalStorageService, CommentService, Utils) {
  'use strict';
  return {
    restrict: 'A',
    link: function ($scope, $element, $attrs) {
      // disable or iOS as it does not handle focusing contenteditable element
      // without (unwanted) jumping at the bottom of the screen
      // http://stackoverflow.com/questions/40487279/calling-element-focus-in-iframe-scrolls-parent-page-to-random-position-in-safa
      if (Utils.iOS()) return

      // Find the content editable element
      if (!$scope.comment._id) {
        $scope.comment.content = LocalStorageService.getItem('commentN1_' + CommentService.thread_id);
      }
      var textArea = angular.element($element[0].querySelector('[contenteditable="true"]'))[0];

      $element.on('click', setFocus);
      var removeListener = $scope.$on("$destroy", onDestroy);

      // Defined a potential excepted class
      var exceptions = null;
      if ($attrs.textareaFocusExcept) {
        exceptions = $parse($attrs.textareaFocusExcept)();
      }

      /**
       * @param event {MouseEvent} The mouse event.
       */
      function setFocus(event) {
        var skipFocus;

        // if clicking on a link in the cgu section
        if ($(event.target).parents('.gc-comment-cgu').length) {
          skipFocus = false;
          return;
        }

        // detect if an excepted class is contained in the event path
        if (exceptions) {
          exceptions.forEach(function(excepted) {
            if (skipFocus) return;
            skipFocus = event.target.matches(excepted);
            if (!skipFocus && event.target.parentNode) {
              skipFocus = event.target.parentNode.matches(excepted);
            }
          });
        } else {
          skipFocus = false;
        }

        // if an excepted class is in the event path, cancel the focus
        if (skipFocus) {
          return;
        }

        event.preventDefault();
        textArea.focus();
      }

      function onDestroy() {
        $element.off('click', setFocus);
        removeListener();
      }
    }
  };
}]);
